<template>
  <div class="md-table-cell-container">
    <router-link
      v-if="canView || canEdit"
      :to="currentRoute + '/' + entityId + '/detail'"
    >
      <md-button class="md-just-icon md-success md-simple table-action">
        <md-tooltip md-direction="top">{{ $t("common.edit") }} </md-tooltip>
        <md-icon v-if="canEdit">edit</md-icon>
        <md-icon v-if="canView && !canEdit">visibility</md-icon>
      </md-button>
    </router-link>

    <md-button
      v-if="canDelete"
      class="md-just-icon md-danger md-simple table-action"
      @click.native="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import { GradeScale } from "@/constants/Permissions";

export default {
  props: ["item"],
  inject: ["confirmDelete"],
  methods: {
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    },

    entityId() {
      return this.item.id || this.item._id;
    },
    canView() {
      return this.$can(GradeScale.actions.view, GradeScale.subject);
    },
    canEdit() {
      return this.$can(GradeScale.actions.edit, GradeScale.subject);
    },
    canDelete() {
      return this.$can(GradeScale.actions.delete, GradeScale.subject);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
